// extracted by mini-css-extract-plugin
export default {"wrapper":"TextWithTooltip_wrapper__tTHmB","text":"TextWithTooltip_text__lttw4"};